const { default: API } = require("../api/API");

function getTotalCost({ businessID, body }) {
  return new Promise((resolve, reject) => {
    API.post(
      `/personal/business/${businessID}/services/total-cost`,
      body
    ).then(resolve, reject);
  });
}

export default getTotalCost;
